import trim from 'lodash/trim';
import isEmpty from 'validator/lib/isEmpty';
import isURL from 'validator/lib/isURL';

import { CONTENT_TYPE, type ContentType } from 'src/data/contentType';
import { isLongFormProjectType, type ProjectType } from 'src/data/project';

const emptyUrlMessage = (projectType?: ProjectType, contentType?: ContentType) => {
  if (projectType && isLongFormProjectType(projectType)) {
    return 'Please enter a URL.';
  }

  return contentType === CONTENT_TYPE.content
    ? 'Please enter a URL of an article or blog post.'
    : 'Please enter a URL. It should have some info about your product/service.';
};

const invalidUrlMessage = (projectType?: ProjectType, contentType?: ContentType) => {
  if (projectType && isLongFormProjectType(projectType)) {
    return 'Please enter a valid URL.';
  }

  return contentType === CONTENT_TYPE.content
    ? 'Please enter a valid URL in format: example.com/your-article'
    : 'Please enter a valid URL in format: example.com/your-product';
};

export interface ValidationResult {
  valid: boolean;
  messages: string[];
  events: Array<{ type: string }>;
}

export interface ValidationOptions {
  contentType?: ContentType;
  projectType?: ProjectType;
}

export const validateUrl = (url: string, options?: ValidationOptions): ValidationResult => {
  const { contentType, projectType } = options || {};

  const messages = [];
  const events = [];

  if (isEmpty(url, { ignore_whitespace: true })) {
    messages.push(emptyUrlMessage(projectType, contentType));
    events.push({ type: 'no_input' });
  } else if (!isURL(trim(url))) {
    messages.push(invalidUrlMessage(projectType, contentType));
    events.push({ type: 'invalid_format' });
  }

  const valid = messages.length === 0;

  return { valid, messages, events };
};
